module.exports = __webpack_public_path__ + "static/media/hot-cat-banner-item-1.97d2af11.png";